export default "__VITE_ASSET__Dp149EcD__"